import React from "react";
import "./GlobalThirdTable.scss";

export const GlobalThirdTable = ({ data, columns, onRowClick }) => (
  <table>
    <thead>
      <tr>
        {columns.map((col, idx) => (
          <th key={idx} className="table_col">
            {/* <div className="global_col"> */}
              <span>{col.label}</span>
            {/* </div> */}
          </th>
        ))}
      </tr>
    </thead>
    <tbody>
      {data.map((row, idx) => (
        <tr key={idx} onClick={() => onRowClick && onRowClick(row)}>
          {columns.map((col, colIdx) => (
            <td key={colIdx}>{row[col.key]}</td>
          ))}
        </tr>
      ))}
    </tbody>
  </table>
);
